import {Component, OnInit, Input} from '@angular/core';
import _ from 'lodash';
import {ReportsService} from '../../reports.service';
import {LoginService} from '../../../services/login.service';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {ApiService} from '../../../services/api.service';
import {Cookie} from 'ng2-cookies/ng2-cookies';
import {LocalStorageService} from 'angular-2-local-storage';
import {GoogleAnalyticsService} from '../../../services/google-analytics-service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'my-report-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  public reports: Array<string> = [];
  perpage = 10;
  TotalPages = 0;
  columns = [
    {name: 'fileName', sort: 'asc', isCurrent: false},
    {name: 'vendors', sort: 'asc', isCurrent: false},
    {name: 'fileSize', sort: 'asc', isCurrent: false},
    {name: 'uploadTime', sort: 'desc', isCurrent: true},
    {name: 'reportedPeriod', sort: 'asc', isCurrent: false}];
  currentPageIndex = 0;
  currentUser: any = {};
  searchString = '';
  lastAppliedSearch = '';
  totalItems = 0;
  pages: number[] = [];
  selectedFile: any;
  ruid: string;
  environment: any = environment;
  lang = localStorage.getItem('lang');
  get currentColumn() {
    return _.find(this.columns, {isCurrent: true}) || {};
  }

  @Input('doNotLoad') doNotLoad = false;

  constructor(private apiService: ApiService,
              private ga: GoogleAnalyticsService,
              private localStorageService: LocalStorageService,
              private loginService: LoginService,
              private reportService: ReportsService,
              private router: Router,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
      }
    });
    this.loginService.isLoggedIn()
      .subscribe((user) => {
          this.currentUser = user;
          if (this.currentUser.isLoggedIn) {
              this.getReportsHistory(this.currentPageIndex, 'uploadTime', 'desc', '');
          }
      // });
      // this.route.params.subscribe(params => {
      //   if (params.reload) {
      //     this.searchData();
      //   }
      });
  }

  changeSelectedFile(report) {
    if (this.selectedFile === report) {
      this.selectedFile = undefined;
    } else {
      this.selectedFile = report;
    }
  }

  getReportsHistory(page, columnName, Sort, search) {
    this.ga.emitEvent('Reports Actions', 'View Report', 'Click');
    
    let date = new Date();
    let userTimeZoneOffset = date.getTimezoneOffset();
    
    this.reportService.getReportHistory(page, this.perpage, columnName, Sort, search, userTimeZoneOffset)
      .subscribe((res) => {
        this.reports = res.json();
        this.totalItems = parseInt(res.headers.get('X-Total-Count'), 10);
        this.TotalPages = Math.ceil(this.totalItems / this.perpage);
        this.pages = [];
        for (let i = 0; i < this.TotalPages; i++) {
          this.pages.push(i);
        }
      }, (error) => {
          this.notifications.error(this.translate.instant('common.error'),
          this.apiService.getMessageFromError(error, this.translate.instant('reports.history.failedRep')));
      });
  }

  searchData() {
    this.ga.emitEvent('Reports Actions', 'Search Report', 'Click');
    const current = this.currentColumn;
    if (this.searchString) {
      this.lastAppliedSearch = this.searchString;
      this.getReportsHistory(this.currentPageIndex, current.name, current.sort, this.lastAppliedSearch);
    } else {
      this.getReportsHistory(this.currentPageIndex, current.name, current.sort, '');
    }
  }

  resetSort() {
    _.each(this.columns, function (column) {
      column.isCurrent = false;
    });
  }

  sortCols(column) {
    let obj = _.find(this.columns, {name: column});
    this.resetSort();
    obj.isCurrent = true;

    if (obj.sort === 'asc') {
      obj.sort = 'desc';
    } else {
      obj.sort = 'asc';
    }
    this.getReportsHistory(this.currentPageIndex, obj.name, obj.sort, `${this.lastAppliedSearch != '' ? this.lastAppliedSearch : ''}`);
  }

  pageIndexChange(pageIndex) {
    this.currentPageIndex = pageIndex - 1;
    const currentColumn = this.currentColumn;
    this.getReportsHistory(this.currentPageIndex, currentColumn.name, currentColumn.sort,
        `${this.lastAppliedSearch != '' ? this.lastAppliedSearch : ''}`);
    return this.currentPageIndex + 1;
  }

  downloadPDF() {
    this.ga.emitEvent('Reports Actions', 'Download PDF', 'Click');
    if (this.selectedFile) {
      const jsessionid = Cookie.get('JSESSIONID');
      window.open(environment.baseURL + `/api/report/pdf;jsessionid=${jsessionid}?ruid=` + encodeURIComponent(this.selectedFile.ruid));
    }
  }

  viewReport(file) {
    this.ga.emitEvent('Reports Actions', 'View Report', 'Click');
    if (!file) {
        file = this.selectedFile;
    }
    if (file) {
      this.localStorageService.remove('isParsed');
      this.localStorageService.set('openLastViewed', true);
      this.router.navigate(['/reports/myreports'], {queryParams: {ruid: file.ruid}});
    }
  }

  deleteReport(file) {
    this.ga.emitEvent('Reports Actions', 'Delete Report', 'Click');
    if (!file) {
        file = this.selectedFile;
    }
    if (file) {
      this.reportService.deleteReport(encodeURIComponent(file.ruid)).subscribe(
        res => {
          this.getReportsHistory(this.currentPageIndex, 'uploadTime', 'desc', '');
          this.selectedFile = {};
        },
        err => {
          console.log('Failed delete report ', err);
        });
    }
  }

  clearSearch(e) {
    e.preventDefault();
    this.lastAppliedSearch = '';
    this.searchString = '';
    this.getReportsHistory(this.currentPageIndex, '', '', this.lastAppliedSearch);
  }

  clearSort(e) {
    e.preventDefault();
    this.resetSort();
    this.getReportsHistory(this.currentPageIndex, '', '', this.lastAppliedSearch);
  }
  
  commonFunction() {
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/history/history.component.ts